import { render, staticRenderFns } from "./Policies.vue?vue&type=template&id=6d3ceb01&scoped=true&"
import script from "./Policies.js?vue&type=script&lang=js&"
export * from "./Policies.js?vue&type=script&lang=js&"
import style0 from "./Policies.scss?vue&type=style&index=0&id=6d3ceb01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3ceb01",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
